import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const Section = styled.section``;

type SectionTitleProps = {
  slim?: boolean;
};

export const SectionTitle = styled.h4<SectionTitleProps>(
  props => css`
    font-size: inherit;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin: 0;
    margin-bottom: ${layout.spacing.small};
    padding: ${layout.spacing.small};
    padding-bottom: 0;

    ${props.slim &&
      css`
        margin-bottom: ${layout.spacing.xSmall};
      `}
  `
);
